
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ClipboardList } from 'lucide-react';

const registersData = [
  { name: "Register of Members", total: 126, lastUpdated: "2025-04-22" },
  { name: "Register of Directors", total: 8, lastUpdated: "2025-04-28" },
  { name: "Register of Loans & Investments", total: 17, lastUpdated: "2025-04-15" },
  { name: "Register of Charges", total: 4, lastUpdated: "2025-03-29" },
  { name: "Register of Contracts", total: 12, lastUpdated: "2025-04-10" },
  { name: "Register of Transfers", total: 8, lastUpdated: "2025-03-18" },
  { name: "Register of Debenture Holders", total: 53, lastUpdated: "2025-04-05" },
  { name: "Register of Fixed Assets", total: 35, lastUpdated: "2025-04-12" }
];

const StatutoryRegistersTab = () => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {registersData.map((register, index) => (
        <Card key={index}>
          <CardHeader className="pb-2">
            <CardTitle className="text-lg flex items-center">
              <ClipboardList className="h-5 w-5 mr-2 text-primary" />
              {register.name}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Total Entries:</span>
                <span className="text-sm">{register.total}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Last Updated:</span>
                <span className="text-sm">{register.lastUpdated}</span>
              </div>
              <Button variant="outline" size="sm" className="w-full mt-2">
                View Register
              </Button>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}

export default StatutoryRegistersTab;
